import { render, staticRenderFns } from "./dual-list.vue?vue&type=template&id=34ad95ee&scoped=true"
import script from "./dual-list.vue?vue&type=script&lang=js"
export * from "./dual-list.vue?vue&type=script&lang=js"
import style0 from "./dual-list.vue?vue&type=style&index=0&id=34ad95ee&prod&lang=css"
import style1 from "./dual-list.vue?vue&type=style&index=1&id=34ad95ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad95ee",
  null
  
)

export default component.exports